import React from "react";

const ChatIcon = ({ color = "black" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8084 17.9084C15.2951 17.6775 18.0718 14.8609 18.3001 11.325C18.3443 10.6334 18.3443 9.9167 18.3001 9.22503C18.0718 5.69003 15.2951 2.87503 11.8084 2.64253C10.6042 2.56317 9.39602 2.56317 8.19177 2.64253C4.7051 2.87419 1.92843 5.69003 1.7001 9.22586C1.65596 9.92517 1.65596 10.6266 1.7001 11.3259C1.78343 12.6134 2.3526 13.8059 3.02343 14.8125C3.4126 15.5167 3.15593 16.3959 2.7501 17.165C2.45843 17.7192 2.31177 17.9959 2.42927 18.1959C2.54593 18.3959 2.80843 18.4025 3.3326 18.415C4.3701 18.44 5.06927 18.1467 5.62427 17.7375C5.93843 17.505 6.09593 17.3892 6.20427 17.3759C6.3126 17.3625 6.52677 17.4509 6.95343 17.6259C7.33677 17.7842 7.7826 17.8817 8.19093 17.9092C9.37843 17.9875 10.6193 17.9875 11.8093 17.9092"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ChatIcon;
